export default [
  {
    name: 'Display Name',
    prop: 'name',
    type: 'text'
  },
  {
    name: 'IPED #',
    prop: 'iped_code',
    type: 'text'
  }
]
